export const BASEURL = "https://imedia-api.growatiopex.com"
export const APIURL = "https://imedia-api.growatiopex.com/playablehub"